import { createPortal } from "react-dom";
import PropTypes from "prop-types";

// Renders children into document.body instead of the local DOM position.
// Overlays that use position: fixed must be portaled out of any ancestor
// that establishes a containing block (e.g. transform, will-change:
// transform), otherwise "fixed" is scoped to that ancestor instead of the
// viewport.
export function Portal({ children }) {
  return createPortal(children, document.body);
}

Portal.propTypes = {
  children: PropTypes.node,
};

export default Portal;
